import { render, staticRenderFns } from "./EditPageCorpPolity.vue?vue&type=template&id=88132080"
import script from "./EditPageCorpPolity.vue?vue&type=script&lang=js"
export * from "./EditPageCorpPolity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports